module.exports = "<div id=app> <navlist></navlist> <div class=container> <search></search> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 7
 ** module chunks = 0
 **/